<button
  mat-icon-button
  class="initials-icon"
  [disabled]="true"
  [style.background]="util.getAvatarGradient(nameInitials)"
  [class.small-initials-icon]="size == 'small'"
  [class.large-initials-icon]="size == 'large'">
  <div class="name-initials">
    <tidy-text 
      *ngIf="!isUnknownNumber"
      [body]="nameInitials">
    </tidy-text>
    <tidy-image
      *ngIf="isUnknownNumber"
      [src]="'assets/img/person-white.svg'"
      style="display: flex; align-items: center; justify-content: center; width: 75%; height: 75%; margin: auto;">
    </tidy-image>
  </div>
</button>
